import type { SelectableSearchCategory } from '~/features/catalog/components/navigation/CategoryNavigation';

/**
 * Ein Klick auf diesen Knoten führt direkt in den Katalog, statt eine weitere Navigationsebene zu öffnen:
 * entweder weil der Knoten keine Unterkategorien hat oder weil es das Gesamtsortiment (type === null) ist.
 */
export function isNavigationLeaf(category: SelectableSearchCategory): boolean {
  return category.children.length === 0 || category.item.type === null;
}
